import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["browserWindowHeight", "browserWindowWidth", "children", "className", "inline", "showCloseButton", "size", "style", "mobile", "widgetLocation", "forwardedRef", "widgetSize"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { RIGHT_ALIGNED, WidgetLocationProp } from '../visitor-widget/constants/WidgetLocations';
import { calculateChatWidgetHeight } from '../widget-dimensions/calculateChatWidgetHeight';
import { calculateChatWidgetWidth } from '../widget-dimensions/calculateChatWidgetWidth';
import { OLAF } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
const sizes = {
  small: 'small',
  'extra-small': 'extra-small',
  default: 'default'
};
export const UPDATED_VISITOR_WIDGET_BORDER_RADIUS = 10;
export const WidgetStyleWrapper = styled.div.withConfig({
  displayName: "VisitorWidgetStyleWrapper__WidgetStyleWrapper",
  componentId: "sc-21wuln-0"
})(["display:flex;flex-direction:column;align-items:flex-end;", " transform-origin:bottom right;"], ({
  inline,
  mobile,
  size
}) => css(["height:", ";width:", ";margin-top:", ";transform:", ";"], (inline || mobile) && '100%', mobile && '100%', inline && '0', size === sizes.small ? 'scale(0.75)' : size === sizes['extra-small'] ? 'scale(0.5)' : undefined));
export const WidgetContentStyleWrapper = styled.div.withConfig({
  displayName: "VisitorWidgetStyleWrapper__WidgetContentStyleWrapper",
  componentId: "sc-21wuln-1"
})(["height:", ";background:", ";overflow:hidden;border-radius:", "px;box-shadow:0 4px 16px rgba(0,0,0,0.1);position:relative;width:", ";transition:bottom 0.25s ease-in-out;transition:all 0.25s ease-in-out;&.inline{box-shadow:none;height:100%;margin:0;width:100%;border-radius:0;}"], ({
  mobile,
  browserWindowHeight,
  showCloseButton,
  widgetSize
}) => !mobile ? `${calculateChatWidgetHeight(browserWindowHeight, widgetSize.height, {
  showCloseButton
})}px` : '100%', OLAF, UPDATED_VISITOR_WIDGET_BORDER_RADIUS, ({
  widgetSize,
  browserWindowWidth
}) => `${calculateChatWidgetWidth(browserWindowWidth || 562, widgetSize.width || 530)}px`);
export const WIDGET_CONTENT_STYLE_WRAPPER_TEST_ID = 'chat-widget-wrapper';
const VisitorWidgetStyleWrapper = props => {
  const {
      browserWindowHeight,
      browserWindowWidth,
      children,
      className,
      inline = false,
      showCloseButton = true,
      size = sizes.default,
      style,
      mobile,
      widgetLocation = RIGHT_ALIGNED,
      forwardedRef,
      widgetSize = {
        width: 376,
        height: 530
      }
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(WidgetStyleWrapper, {
    style: style,
    inline: inline,
    size: size,
    mobile: !!mobile,
    "data-test-id": "widget-style-wrapper",
    children: /*#__PURE__*/_jsx(WidgetContentStyleWrapper, Object.assign({
      browserWindowWidth: browserWindowWidth,
      className: classNames('chat-widget', className, mobile && "mobile", inline && "inline"),
      "data-test-id": WIDGET_CONTENT_STYLE_WRAPPER_TEST_ID,
      widgetSize: widgetSize,
      browserWindowHeight: browserWindowHeight,
      widgetLocation: widgetLocation,
      mobile: !!mobile,
      showCloseButton: !!showCloseButton,
      ref: forwardedRef
    }, rest, {
      children: children
    }))
  });
};
VisitorWidgetStyleWrapper.propTypes = {
  browserWindowHeight: PropTypes.number.isRequired,
  browserWindowWidth: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  forwardedRef: PropTypes.object,
  inline: PropTypes.bool.isRequired,
  mobile: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(sizes)).isRequired,
  style: PropTypes.object,
  widgetLocation: WidgetLocationProp,
  widgetSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }).isRequired
};
VisitorWidgetStyleWrapper.displayName = 'VisitorWidgetStyleWrapper';
export default VisitorWidgetStyleWrapper;